import { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard } from "lucide-react";
import { useCustomerAuth } from "@/hooks/useCustomerAuth";
import { fetchCustomerWebsites } from "@/lib/api";
import { slugForConceptPath } from "@/hooks/useConceptLifecycleStatus";

const QA_PATHS = {
  "/qa/mysitecare-qa-website-1": "mysitecare-qa-website-1",
  "/qa/mysitecare-qa-website-2": "mysitecare-qa-website-2",
  "/qa/mysitecare-qa-website-3": "mysitecare-qa-website-3",
};

export default function CustomerWebsiteAccessLayer() {
  const { pathname } = useLocation();
  const { token, isLoggedIn } = useCustomerAuth();
  const slug = useMemo(() => slugForConceptPath(pathname) || QA_PATHS[pathname], [pathname]);
  const [footerMount, setFooterMount] = useState(null);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    setHasAccess(false);
    if (!slug || !token || !isLoggedIn) return;
    fetchCustomerWebsites(token).then((sites) => setHasAccess(sites.some((site) => site.slug === slug))).catch(() => {});
  }, [slug, token, isLoggedIn]);

  useEffect(() => {
    if (!slug) return undefined;
    const footer = [...document.querySelectorAll("footer")].pop();
    if (!footer) return undefined;
    const node = document.createElement("div");
    node.dataset.mscCustomerFooter = slug;
    footer.appendChild(node);
    setFooterMount(node);
    return () => { node.remove(); setFooterMount(null); };
  }, [pathname, slug]);

  if (!slug) return null;
  return <>{hasAccess && <Link to={`/account/websites/${slug}/overview`} className="fixed right-4 top-4 z-[10000] inline-flex items-center gap-2 rounded-full bg-slate-950 px-4 py-2 text-sm font-semibold text-white shadow-xl" data-testid="customer-site-dashboard"><LayoutDashboard size={16} /> Dashboard</Link>}{footerMount && createPortal(<a href="https://mysitecare.eu" className="notranslate mx-auto my-3 block w-fit text-xs opacity-75 hover:opacity-100" translate="no">Website by MySiteCare</a>, footerMount)}</>;
}
